import { createContext } from "react";

export const TeamNavigatorContext = createContext<{
  teamId: string;
  hasTabBar: boolean;
}>({
  teamId: "",
  hasTabBar: true,
});
